import { normalizeCompanyWhatsApp } from '@/lib/company/public-info';
export const COMPANY_CLAIM_URL = 'https://admin.viratempo.app';

export function buildCompanyClaimMessage(companyName?: string) {
  return 'Oi! Encontrei vocês no Vira Tempo e vi que os agendamentos online ainda não estão liberados. Vocês pretendem ativar isso em breve?';
}

export function buildCompanyClaimWhatsAppUrl(phoneNumber?: string | null, companyName?: string) {
  let normalizedPhoneNumber: string | null;
  try {
    normalizedPhoneNumber = normalizeCompanyWhatsApp(phoneNumber)?.slice(1) ?? null;
  } catch {
    return null;
  }

  if (!normalizedPhoneNumber) {
    return null;
  }

  return `https://wa.me/${normalizedPhoneNumber}?text=${encodeURIComponent(buildCompanyClaimMessage(companyName))}`;
}
